import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import wtaLogo from "@/assets/wta-logo.png";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) navigate("/members", { replace: true });
    });
  }, [navigate]);

  const handleSend = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: `${window.location.origin}/members/welcome` },
    });
    setSending(false);
    if (error) toast.error(error.message);
    else {
      setSent(true);
      toast.success("Check your email for a sign-in link.");
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-sm space-y-8 text-center">
        <img src={wtaLogo} alt="WTA" className="w-20 h-20 mx-auto object-contain" />
        <div className="space-y-2">
          <h1 className="font-display text-2xl font-bold text-foreground">Members Sign-In</h1>
          <p className="text-muted-foreground font-body text-sm">
            Enter your email and we'll send you a one-tap sign-in link.
          </p>
        </div>
        {sent ? (
          <p className="text-gold font-body text-sm">
            Sign-in link sent. Check <span className="text-foreground">{email}</span>.
          </p>
        ) : (
          <form onSubmit={handleSend} className="space-y-4">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full px-4 py-3 bg-secondary/50 border border-gold/20 text-foreground font-body text-sm focus:outline-none focus:border-gold/60"
            />
            <button
              type="submit"
              disabled={sending}
              className="w-full py-3 bg-gradient-gold text-primary-foreground font-body text-sm font-semibold uppercase tracking-[0.2em] disabled:opacity-50"
            >
              {sending ? "Sending..." : "Send sign-in link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Login;
